import * as React from 'react';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { bemElement } from 'af-utils/bem.util';

type Props = {
	equipmentMinutes: number;
	jobMinutes: number;
	label: string;
	className?: string;
};

const EquipmentTimeError: React.FC<Props> = ({ equipmentMinutes, jobMinutes, label, className }) => {
	const equipmentTime = TimeUtils.minutesToHoursAndMinutes(equipmentMinutes);
	const jobTime = TimeUtils.minutesToHoursAndMinutes(jobMinutes);

	return (
		<div
			className={[
				bemElement('time-sheet-list__equipment-modal', 'equipment-time-error'),
				className,
			].filter(Boolean).join(' ')}
		>
			<span className="icon-info" />
			{`Equipment time (${equipmentTime}) exceeds Job time (${jobTime}) for ${label}`}
		</div>
	);
};

export default React.memo(EquipmentTimeError);
